import router from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'
import { Message } from 'element-ui'
NProgress.configure({ showSpinner: false })

const whiteList = ['/login', '/auth-redirect']

router.beforeEach(async(to, from, next) => {
        NProgress.start()
        document.title = getPageTitle(to.meta.title)
        const hasToken = getToken()
        if (hasToken) {
            if (to.path === '/login') {
                next({ path: '/' })
                NProgress.done()
            } else {
                if (store.getters.roles.length === 0) { // 判断当前用户是否已拉取完user_info信息
                    // 判断当前用户是否已拉取完user_info信息
                    store.dispatch('user/GetUserInfo').then(res => {
                      // 拉取user_info
                      const roles = res.data.roles
                      store.dispatch('permission/GenerateRoutes', { roles }).then(accessRoutes => {
                        // 根据roles权限生成可访问的路由表
                        router.addRoutes(accessRoutes) // 动态添加可访问路由表
                        next({ ...to, replace: true }) // hack方法 确保addRoutes已完成
                      })
                    }).catch(err => {
                      store.dispatch('user/Logout').then(() => {
                        Message.error(err)
                        next({ path: '/' })
                      })
                    })
                } else {
                    next()
                }
            }
        } else {
            if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
                next()
            } else {
                next(`/login?redirect=${to.fullPath}`)
                NProgress.done()
            }
        }
    })
  router.afterEach(() => {
      NProgress.done()
  })
